<template>
  <div class="ui-form-field ui-form-field--range" :class="rootClasses">
    <label>
      <span v-if="$scopedSlots.label" class="ui-form-field__title-label">
        <slot name="label" />
      </span>
      <div class="ui-form-field__input-container">
        <slot name="input">
          <input
            v-model="currentValue"
            type="range"
            :min="min"
            :max="max"
            class="ui-form-field__input"
            v-bind="$attrs"
            @focus="onFocus"
            @blur="onBlur"
            v-on="$listeners"
          />
        </slot>
      </div>
    </label>
    <slot name="messages" />
  </div>
</template>

<script>
  import bemMixin from '@/assets/js/mixin/bem'
  import rootClassesMixin from '@/assets/js/mixin/root-classes'
  import focusBehaviourMixin from '@/assets/js/mixin/focus-behaviour'
  import currentValueMixin from '@/assets/js/mixin/current-value'
  import hasErrorsPropsMixin from '@/assets/js/mixin/has-error-props'

  export default {
    components: {},
    mixins: [
      bemMixin('ui-form-field'),
      focusBehaviourMixin,
      rootClassesMixin,
      currentValueMixin,
      hasErrorsPropsMixin,
    ],
    props: {
      value: {
        type: Number,
        default: 0,
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 1,
      },
    },
  }
</script>
